import React from 'react';
import {Suspense} from "react";
import {Fallback} from "./Fallback";
import {GoogleMap, GoogleMapApiLoader} from 'react-google-map-wrapper';
import UserLocation from "./UserLocation";
import MapItinerary from "./MapItinerary";
import {ParsedGPX, parseGPX} from "@we-gold/gpxjs"
import Select from 'react-select'
import {Itinerary} from "../interface/Itinerary";
import {getPointsOfInterests} from "../data/PointsOfInterest";
import harvesine from 'haversine-distance';


let publicPath: string
process.env.NODE_ENV === 'development' ?
    publicPath = './' :
    publicPath = '/_Resources/Static/Packages/TC.Website/JavaScript/experientiel-web-app/'

const GoogleMaps: React.FC = () => {
    const [map, setMap] = React.useState<google.maps.Map>()
    const [itinerary, setItinerary] = React.useState<Itinerary>()
    const [userPosition, setUserPosition] = React.useState<GeolocationPosition>()

    const itineraries = [
        {value: 'tour-de-treme', label: 'La Tour-de-Trême'},
        {value: 'blonay', label: 'Blonay'},
        {value: 'paccots', label: 'Les Paccots'},
        {value: 'joncs', label: 'Lac des Joncs'}
    ]

    const getItineraryData = async (itineraryId: string) => {
        return fetch(`${publicPath}gpx/${itineraryId}.gpx`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch the GPX file of: " + itineraryId)
                }
                return response.text()
            })
            .then((data) => {
                const [gpxData, error] = parseGPX(data)
                if (error) throw error

                return gpxData
            })
    }

    const onSelectChange = (selectedOption: any) => {
        loadItinerary(map, selectedOption.value)
    }

    const loadItinerary = React.useCallback((map: google.maps.Map | undefined, itineraryId: string = 'tour-de-treme') => {
        setMap(map)
        getItineraryData(itineraryId)
            .then((gpxData: ParsedGPX) => {
                let routePoints: (google.maps.LatLng | google.maps.LatLngLiteral)[] = []
                let bounds = new google.maps.LatLngBounds()

                if (gpxData.tracks.length > 0) {
                    gpxData.tracks[0].points.forEach((point) => {
                        routePoints.push({lat: point.latitude, lng: point.longitude})
                        bounds.extend({lat: point.latitude, lng: point.longitude})
                    })
                    map!.fitBounds(bounds)
                    setItinerary({
                        id: itineraryId,
                        points: routePoints,
                        pointsOfInterest: getPointsOfInterests(itineraryId)
                    })
                }
            })
    }, [])

    const onUserPositionUpdate = (position: GeolocationPosition) => {
        setUserPosition(position)

        itinerary && itinerary.pointsOfInterest.forEach((pointOfInterest) => {
            const distance = harvesine(position.coords, pointOfInterest.geopoint )

            if (distance < 50) {
                console.log(`You are near ${pointOfInterest.title}`)
            }
        })
    }

    return (
        <div id="map-container">
            <Suspense fallback={<Fallback/>}>
                <GoogleMapApiLoader apiKey='AIzaSyB2187-Oj685Oe8hhXVOZ8AMyeYSCgcz6Q' suspense>
                    <GoogleMap
                        onLoad={loadItinerary}
                        mapOptions={{
                            mapId: 'itineraries-map',
                            streetViewControl: false,
                            fullscreenControl: false,
                            zoomControl: true
                        }}
                        style={{width: '100vw', height: '72vh'}}>

                        {
                            itinerary ?
                                <MapItinerary itinerary={itinerary}/>
                                : <></>
                        }

                        <UserLocation onPositionUpdate={onUserPositionUpdate}/>
                    </GoogleMap>
                </GoogleMapApiLoader>
            </Suspense>

            <div id={'user-position'} style={{marginTop: '40px'}}>
                User position: lat: {userPosition?.coords.latitude}, lng: {userPosition?.coords.longitude}
            </div>

            <div id={'itinerary-select'} style={{marginTop: '40px'}}>
                <div id={'select-wrapper'} style={{width: '280px', margin: 'auto', marginTop: '20px'}}>
                    <Select
                        placeholder={'Itinéraires'}
                        options={itineraries}
                        defaultValue={itineraries[0]}
                        onChange={onSelectChange}
                        isSearchable={false}/>
                </div>
            </div>
        </div>
    );
}

export default GoogleMaps;
